import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { getItemWebStorage } from "../../features/webStorageSaver";

function getInitialState() {
    const initialState = {
        contentHeaderIsExpanded: false,
        rosreestrIsEnabled: getItemWebStorage('mapSettings')?.rosreestrIsEnabled,
        rosreestrIsAvailable: true,
        areaMeasurementIsEnabled: false,
        perimeterMeasurementIsEnabled: false,
        copyCoordsButtonIsClicked: false,
        copyCoordsTypeIsChosen: false,
        goToYandexMirrorsButtonIsClicked: false,
        trafficPlanPositionSelectionIsEnabled: false,
        navigateToPanoButtonIsClicked: false,
        tableUnderMapIsShown: false,
        searchLineIsShown: false,
        showUserLocationButtonIsClicked: false,
        highContrastModeIsEnabled: false,
        panoramaUnderMapIsShown: false,
        printButtonIsClicked: false,
        tableInfoWindowIsShown: false,
        tablePDFExportWindowIsShown: false,
        tableCSVExportWindowIsShown: false,
        tableEXCELExportWindowIsShown: false,
        mapRankingIsEnabled: false,
        mapTooltipIsEnabled: true
    }
    return initialState
}

export const contentHeaderSlice = createSlice({
    name: 'contentHeader',
    initialState: getInitialState(),
    reducers: {
        setContentHeaderIsExpanded(state, action: PayloadAction<boolean>) {
            state.contentHeaderIsExpanded = action.payload
        },
        setRosreestrIsEnabled(state, action: PayloadAction<boolean>) {
            state.rosreestrIsEnabled = action.payload
        },
        setRosreestrIsAvailable(state, action: PayloadAction<boolean>) {
            state.rosreestrIsAvailable = action.payload
        },
        setAreaMeasurementIsEnabled(state, action: PayloadAction<boolean>) {
            state.areaMeasurementIsEnabled = action.payload
            state.perimeterMeasurementIsEnabled = false
            state.copyCoordsButtonIsClicked = false
            state.goToYandexMirrorsButtonIsClicked = false
            state.trafficPlanPositionSelectionIsEnabled = false
            state.mapTooltipIsEnabled = false
        },
        setPerimeterMeasurementIsEnabled(state, action: PayloadAction<boolean>) {
            state.perimeterMeasurementIsEnabled = action.payload
            state.copyCoordsButtonIsClicked = false
            state.areaMeasurementIsEnabled = false
            state.goToYandexMirrorsButtonIsClicked = false
            state.trafficPlanPositionSelectionIsEnabled = false
            state.mapTooltipIsEnabled = false
        },
        setCopyCoordsButtonIsClicked(state, action: PayloadAction<boolean>) {
            state.copyCoordsButtonIsClicked = action.payload
            state.perimeterMeasurementIsEnabled = false
            state.areaMeasurementIsEnabled = false
            state.goToYandexMirrorsButtonIsClicked = false
            state.trafficPlanPositionSelectionIsEnabled = false
            state.mapTooltipIsEnabled = false
        },
        setCopyCoordsTypeIsChosen(state, action: PayloadAction<any>) {
            state.copyCoordsTypeIsChosen = action.payload
        },
        setGoToYandexMirrorsButtonIsClicked(state, action: PayloadAction<boolean>) {
            state.goToYandexMirrorsButtonIsClicked = action.payload
            state.areaMeasurementIsEnabled = false
            state.perimeterMeasurementIsEnabled = false
            state.copyCoordsButtonIsClicked = false
            state.trafficPlanPositionSelectionIsEnabled = false
            state.mapTooltipIsEnabled = false
        },
        setTrafficPlanPositionSelectionIsEnabled(state, action: PayloadAction<boolean>) {
            state.trafficPlanPositionSelectionIsEnabled = action.payload
            state.areaMeasurementIsEnabled = false
            state.perimeterMeasurementIsEnabled = false
            state.copyCoordsButtonIsClicked = false
            state.goToYandexMirrorsButtonIsClicked = false
            state.mapTooltipIsEnabled = false
        },
        setNavigateToPanoButtonIsClicked(state, action: PayloadAction<boolean>) {
            state.navigateToPanoButtonIsClicked = action.payload
        },
        setTableUnderMapIsShown(state, action: PayloadAction<boolean>) {
            state.tableUnderMapIsShown = action.payload
        },
        setSearchLineIsShown(state, action: PayloadAction<boolean>) {
            state.searchLineIsShown = action.payload
            state.copyCoordsButtonIsClicked = false
        },
        setShowUserLocationButtonIsClicked(state, action: PayloadAction<boolean>) {
            state.showUserLocationButtonIsClicked = action.payload
        },
        setHighContrastModeIsEnabled(state, action: PayloadAction<boolean>) {
            state.highContrastModeIsEnabled = action.payload
        },
        setPanoramaUnderMapIsShown(state, action: PayloadAction<boolean>) {
            state.panoramaUnderMapIsShown = action.payload
        },
        setPrintButtonIsClicked(state, action: PayloadAction<boolean>) {
            state.printButtonIsClicked = action.payload
        },
        setTableInfoWindowIsShown(state, action: PayloadAction<boolean>) {
            state.tableInfoWindowIsShown = action.payload
            state.tablePDFExportWindowIsShown = false
            state.tableCSVExportWindowIsShown = false
            state.tableEXCELExportWindowIsShown = false
        },
        setTablePDFExportWindowIsShown(state, action: PayloadAction<boolean>) {
            state.tablePDFExportWindowIsShown = action.payload
            state.tableInfoWindowIsShown = false
            state.tableCSVExportWindowIsShown = false
            state.tableEXCELExportWindowIsShown = false
        },
        setTableCSVExportWindowIsShown(state, action: PayloadAction<boolean>) {
            state.tableCSVExportWindowIsShown = action.payload
            state.tableInfoWindowIsShown = false
            state.tablePDFExportWindowIsShown = false
            state.tableEXCELExportWindowIsShown = false
        },
        setTableEXCELExportWindowIsShown(state, action: PayloadAction<boolean>) {
            state.tableEXCELExportWindowIsShown = action.payload
            state.tableInfoWindowIsShown = false
            state.tablePDFExportWindowIsShown = false
            state.tableCSVExportWindowIsShown = false
        },
        setMapRankingIsEnabled(state, action: PayloadAction<boolean>) {
            state.mapRankingIsEnabled = action.payload
        },
        setMapTooltipIsEnabled(state, action: PayloadAction<boolean>) {
            state.mapTooltipIsEnabled = action.payload
            state.trafficPlanPositionSelectionIsEnabled = false
            state.areaMeasurementIsEnabled = false
            state.perimeterMeasurementIsEnabled = false
            state.copyCoordsButtonIsClicked = false
            state.goToYandexMirrorsButtonIsClicked = false
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setContentHeaderIsExpanded,
    setRosreestrIsEnabled,
    setRosreestrIsAvailable,
    setAreaMeasurementIsEnabled,
    setPerimeterMeasurementIsEnabled,
    setCopyCoordsButtonIsClicked,
    setCopyCoordsTypeIsChosen,
    setGoToYandexMirrorsButtonIsClicked,
    setTrafficPlanPositionSelectionIsEnabled,
    setNavigateToPanoButtonIsClicked,
    setHighContrastModeIsEnabled,
    setSearchLineIsShown,
    setShowUserLocationButtonIsClicked,
    setTableUnderMapIsShown,
    setPanoramaUnderMapIsShown,
    setPrintButtonIsClicked,
    setTableInfoWindowIsShown,
    setTablePDFExportWindowIsShown,
    setTableCSVExportWindowIsShown,
    setTableEXCELExportWindowIsShown,
    setMapRankingIsEnabled,
    setMapTooltipIsEnabled
} = contentHeaderSlice.actions
export const contentHeaderReducer = contentHeaderSlice.reducer;
